import axios from "axios";

class AuthApi {
  async login({ email, password }) {
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    const apiPath = `${process.env.REACT_APP_BACKEND_URL}/admin/login`;
    try {
      const resp = await axios.post(
        apiPath,
        {
          email,
          password,
        },
        axiosConfig
      );
      return resp.data;
    } catch (err) {
      const status = err.response?.status;
      if (status === 401 || status === 403 || status === 400) {
        throw new Error("Incorrect email or password.");
      }
      const apiMessage = err.response?.data?.message
        || err.response?.data?.error;
      throw new Error(apiMessage || "Unable to log in. Please try again.");
    }
  }

  async verifyOtp({ email, code }) {
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    const apiPath = `${process.env.REACT_APP_BACKEND_URL}/admin/auth/verify-otp`;
    const resp = await axios.post(
      apiPath,
      {
        email,
        code,
      },
      axiosConfig
    );
    if (resp.status !== 200) {
      throw resp.data;
    } else {
      return resp.data;
    }
  }

  async me() {
    // Auth rides on the httpOnly adminAccessToken cookie (CHO-1473); the request
    // interceptor attaches credentials, so no bearer header is needed.
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    const apiPath = `${process.env.REACT_APP_BACKEND_URL}/admin/get-admin-user`;
    const resp = await axios.get(apiPath, axiosConfig);
    if (resp.status !== 200) {
      throw resp.data;
    } else {
      const user = resp.data;
      return {
        id: user.id,
        avatar: null,
        email: user.email,
        firstname: user.firstname,
        lastname: user.lastname,
        roles: user.roles,
        permissions: user.permissions,
        name: `${user?.firstname?.toLowerCase()} ${user?.lastname?.toLowerCase()}`,
        is_async: user.is_async,
      };
    }
  }

  async logout() {
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    const apiPath = `${process.env.REACT_APP_BACKEND_URL}/admin/logout`;
    await axios.get(apiPath, axiosConfig);
  }
}

export const authApi = new AuthApi();
